import { Button } from "@mantine/core"
import { primaryColor } from "../../../../constants/theme"
import { IconEdit } from "@tabler/icons-react"
import { useNavigate } from "react-router-dom";

export const EditProfileButton = ({width}: {width?: number}) => {

    const navigate = useNavigate();

    const handleClick = () => {
      navigate('/edit-profile');
    };

    return (
        <Button variant="outline" color={primaryColor} leftSection={<IconEdit size={20} />} onClick={handleClick} w={width}>
            Edit Profile
        </Button>
    );

}


